import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { getAssetPath } from '@/constants/configs';

export const BankLogo = styled(props => (
  <center>
    <img
      data-element="bank-logo"
      src={getAssetPath('/logo-with-text.svg')}
      {...props}
    />
  </center>
))(({ theme }) => ({
  marginBottom: theme.spacing(8),
  width: 160,
}));

export const BrowserDetectorIcon = styled(props => (
  <center>
    <img
      src={getAssetPath('/icon-warning.svg')}
      alt="Browser Detector Icon"
      {...props}
    />
  </center>
))(({ theme }) => ({
  width: 116,
  marginBottom: theme.spacing(3),
}));

export const BrowserDetectorDialog = styled(Dialog)(({ theme }) => ({
  '[data-element="bank-logo"]': {
    display: 'none',
  },

  '.MuiDialog-paperFullScreen': {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '.MuiDialogContent-root': {
      flexGrow: 0,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },

    '[data-element="bank-logo"]': {
      display: 'block',
    },
  },
}));

export const BrowserDetectorContainer = styled(DialogContent)(({ theme }) => ({
  maxWidth: 440,
  padding: theme.spacing(4),

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%',
}));

export const BrowserDetectorContent = styled(Box)(({ theme }) => ({
  '.MuiTypography-root': {
    marginBottom: theme.spacing(2.5),
  },

  '.MuiTypography-body1Bold': {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0),
  },

  ul: {
    marginTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(4),
  },
}));

export const BrowserDetectorAction = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3),
  marginTop: theme.spacing(4),

  '.MuiButton-root': {
    flex: 1,
  },
}));
